export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8998.b58c81a4.jpg";